<template>
  <div class="lp-step bg-people-blur">
    <div class="lp-popup">
      <lp-auth-2
        v-if="authType === 1"
        :age="age"
        :loading="loading"
        :username="username"
        @lpUserAction="$emit('lpUserAction', $event)"
        @nextStep="$emit('nextStep')"
        @setLoading="$emit('setLoading', $event)"
      />
      <lp-auth-3
        v-if="authType === 2"
        :age="age"
        :loading="loading"
        :step="step"
        :temp-user="tempUser"
        :username="username"
        @lpUserAction="$emit('lpUserAction', $event)"
        @nextStep="$emit('nextStep')"
        @setLoading="$emit('setLoading', $event)"
        @updateTempUser="$emit('updateTempUser', $event)"
      />
    </div>
  </div>
</template>

<script>
import LpAuth2 from '@/components/Lp/LpAuth2.vue'
import LpAuth3 from '@/components/Lp/LpAuth3.vue'

export default {
  name: 'Lp3Step4',
  components: {
    LpAuth2,
    LpAuth3,
  },
  props: {
    age: {
      type: Number,
      default: 18,
    },
    authType: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
    // eslint-disable-next-line vue/require-prop-types
    tempUser: {
      default: null,
    },
    username: {
      type: String,
      default: '',
    },
  },
}
</script>
